<template>
  <v-dialog max-width="1200px" persistent v-model="dialog">
    <v-card>
      <v-card-title>
        <span class="headline">DO追加请求設定</span>
      </v-card-title>
      <v-card-actions>
        <v-btn :disabled="!canSave" @click="save" color="success" v-permit.SHARP_LFL_SAVE>保存</v-btn>
        <v-btn @click="reback">戻る</v-btn>
      </v-card-actions>
      <v-card-text>
        <v-form>
          <v-container fluid grid-list-md>
            <v-layout row wrap>
              <v-flex xs3>
                <v-text-field :value="shipment.doNo" disabled label="D/O NO"/>
              </v-flex>
              <v-flex xs3>
                <remote-select
                  clearable
                  label="通関料区分"
                  url="/customs-declaration-paper-types/kv"
                  v-model="shipment.customsDeclarationPaperTypeId"
                />
              </v-flex>
              <v-flex xs3>
                <v-select
                  :items="eiajItems"
                  clearable
                  label="無償EIAJ発行"
                  required
                  v-model="shipment.freeEiajIssue"
                />
              </v-flex>
              <v-flex xs3>
                <v-select
                  :items="freeItems"
                  clearable
                  label="無償按分"
                  required
                  v-model="shipment.freeAllocation"
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
        <v-data-table
          :headers="headers"
          :hide-actions="true"
          :items="items"
          :rows-per-page-items="[10]"
          class="inline-edit"
        >
          <template slot="items" slot-scope="props">
            <td>{{props.item.branchCode}}</td>
            <td>{{props.item.sjlWarehouseCode}}&nbsp;{{props.item.sjlWarehouseName}}</td>
            <td>{{props.item.finallyWarehouseCode}}&nbsp;{{props.item.finallyWarehouseName}}</td>
            <td>
              <v-text-field type="number" v-model.number="props.item.append1"/>
            </td>
            <td>
              <v-text-field type="number" v-model.number="props.item.append2"/>
            </td>
            <td>
              <v-text-field type="number" v-model.number="props.item.append3"/>
            </td>
            <td>
              <v-text-field type="number" v-model.number="props.item.append4"/>
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    shipment: {},
    headers: [
      { text: '枝番', value: '', sortable: false },
      { text: 'SJL納入場所', value: '', sortable: false },
      { text: 'SJL納入場所', value: '', sortable: false },
      { text: '追加請求（課税1）', value: '', sortable: false },
      { text: '追加請求（課税2）', value: '', sortable: false },
      { text: '追加請求（課税3）', value: '', sortable: false },
      { text: '追加請求（免税）', value: '', sortable: false }
    ],
    items: [],
    dialog: false,
    eiajItems: ['発行する', '発行しない'],
    freeItems: ['按分する', '按分しない'],
    resolve: null,
    reject: null
  }),
  computed: {
    canSave() {
      return (
        this.shipment.freeAllocation != null &&
        this.shipment.customsDeclarationPaperTypeId != null &&
        this.shipment.freeEiajIssue
      )
    },
    canCalFee() {
      return 'DO業者確認済,DO諸掛登録済'.indexOf(this.shipment.status) !== -1
    }
  },

  methods: {
    popup(sa) {
      this.dialog = true
      this.shipment = sa
      this.items = this.shipment.deliveryOrders
        .filter(d => d.branchCode !== '999' || !d.isSplit)
        .map(d => {
          return {
            ...d,
            append1: this.getAppend(d, '追加請求（課税１）'),
            append2: this.getAppend(d, '追加請求（課税２）'),
            append3: this.getAppend(d, '追加請求（課税３）'),
            append4: this.getAppend(d, '追加請求（免税）')
          }
        })
        .sort((a, b) => a.branchCode.localeCompare(b.branchCode))
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    getCharge(order, typeName) {
      return order.charges.find(c => c.chargeName === typeName)
    },
    getAppend(order, typeName) {
      let charge = this.getCharge(order, typeName)
      return (charge && charge.jpySubTotal) || 0.0
    },
    buildDeliverOrdersCharges() {
      this.shipment.deliveryOrders = this.items.map(this.buildCharges)
    },
    updateOrCreateCharge(order, type, value) {
      let charge = this.getCharge(order, type) || {
        chargeName: type,
        shipmentId: order.id
      }
      charge.jpySubTotal = value
      return charge
    },
    buildCharges(order) {
      let charges = order.charges.filter(
        c => !c.chargeName || c.chargeName.indexOf('追加請求') === -1
      )
      charges = [
        ...charges,
        this.updateOrCreateCharge(order, '追加請求（課税１）', order.append1),
        this.updateOrCreateCharge(order, '追加請求（課税２）', order.append2),
        this.updateOrCreateCharge(order, '追加請求（課税３）', order.append3),
        this.updateOrCreateCharge(order, '追加請求（免税）', order.append4)
      ]

      order.charges = charges
      return order
    },
    save() {
      this.buildDeliverOrdersCharges()
      this.$http
        .put(`/shipping-advices/${this.shipment.id}`, this.shipment)
        .then(res => {
          this.dialog = false
          this.resolve()
        })
    },
    reback() {
      this.resolve()
      this.dialog = false
    }
  }
}
</script>